import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type CreditAnalyticsParams } from '../types';
import META from './useTrackCreditPackPurchased.meta';

export type UseTrackCreditPackPurchasedParams = CreditAnalyticsParams & {
  pack_quantity: number;
  mrr_impact: number;
};

export const useTrackCreditPackPurchased = () => {
  const { track } = useAnalyticsUtilities();

  const trackCreditPackPurchased = useCallback(
    (params: UseTrackCreditPackPurchasedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCreditPackPurchased };
};
